import { apiRequest } from '../api/client';

export async function openSignedDocument(documentId: number): Promise<void> {
  const response = await apiRequest<{ url: string }>(`/api/documents/${documentId}/signed-url`);
  window.open(response.url, '_blank', 'noopener,noreferrer');
}
